module.exports = __webpack_public_path__ + "static/img/6.adb4593.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/zh/6.png
// module id = Ai8q
// module chunks = 0